import { useMutationState } from '@tanstack/react-query';
import { MultiCurrencyConfigurationUpdateParameters, useRepositoryMutation } from '@mews-commander/data-access';

type MutateMulticurrencyConfigurationVariables = Pick<
    MultiCurrencyConfigurationUpdateParameters,
    'isDccMultiCurrencyServiceEnabled' | 'isFxMultiCurrencyServiceEnabled'
>;

export const useMutateMulticurrencyConfiguration = () => {
    const { mutate, isPending } = useRepositoryMutation('multiCurrencyServiceConfiguration', 'update', {
        invalidateQueries: {
            multiCurrencyServiceConfiguration: ['get'],
        },
    });

    const mutationStateVariables = useMutationState({
        filters: { mutationKey: ['multiCurrencyServiceConfiguration', 'update'] },
        select: (mutation) => mutation.state.variables as MutateMulticurrencyConfigurationVariables | undefined,
    });

    const latestMutationStateVariables = mutationStateVariables?.[mutationStateVariables.length - 1];

    return {
        mutate,
        isPending,
        latestMutationStateVariables,
    };
};
